import type { OPERATION_TYPE } from './constants';
import { EXTRA_PARAMS_LABELS } from './constants';

type ExtraParam = {
  title: string;
  value: string | number | boolean | null;
};

// Recursively visits the object and collects filled extra params
export function parseExtraParams(
  object: unknown,
  operationType: OPERATION_TYPE,
): ExtraParam[] {
  const results: ExtraParam[] = [];
  const labels = EXTRA_PARAMS_LABELS[operationType];

  const isPlainObject = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null && !Array.isArray(value);

  const isPrimitive = (
    value: unknown,
  ): value is string | number | boolean | Date =>
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    value instanceof Date;

  const isFilled = (value: unknown): boolean =>
    value !== null &&
    value !== undefined &&
    (typeof value !== 'string' || value.trim() !== '');

  const visit = (val: unknown, key?: string) => {
    const title = key ? labels[key] : undefined;
    if (title && isPrimitive(val) && isFilled(val)) {
      results.push({
        title,
        value: val instanceof Date ? val.toISOString() : val,
      });
      return;
    }

    if (Array.isArray(val)) {
      val.forEach((item) => visit(item));
      return;
    }

    if (isPlainObject(val)) {
      Object.entries(val).forEach(([key, value]) => visit(value, key));
    }
  };

  visit(object);
  return results;
}
